export default function initJqueryAddons() {

	/**
	 * Sets the icon of an element to a number with a prefix and suffix.
	 * @param {number} num - The number to display.
	 * @param {string} [preffix] - The prefix to add before the number.
	 * @param {string} [suffix] - The suffix to add after the number.
	 */
	$.fn.setIconCounter = function (num, preffix, suffix) {
		let el = $(this);
		if (typeof preffix == 'undefined') {
			preffix = '';
		}

		if (typeof suffix == 'undefined') {
			suffix = '';
		}

		el.html(el.find('i')[0].outerHTML + preffix + num + suffix);
	};

	/**
	 * Highlights an element by coloring its background for the given duration.
	 *
	 * @param {string} [color] - The color to use for the highlight.
	 * @param {number} [duration] - The duration of the highlight, in milliseconds.
	 */
	$.fn.highlight = function (color, duration) {
		// highlight element by coloring its background for the given duration
		// -- alternate function of jQueryUI.fn.effect('highlight')
		if (typeof color == 'undefined') color = '#ffff99';
		if (typeof duration == 'undefined') duration = 3000;
		let element = $(this),
			ori_bg_color = element.css('background-color'),
			ori_style = element.prop('style') ?? "";
		// highlight
		element.css({ 'background-color': color, 'transition': 'background-color ' + (duration * .00015) + 's ease' });
		// ease out
		setTimeout(function () {
			element.css({ 'background-color': ori_bg_color, 'transition': 'background-color ' + (duration * .00085) + 's ease' });
		}, (duration * .15));
		// clear highlight properties
		setTimeout(function () {
			element.prop('style', ori_style);
		}, (duration * .85));
	};

	/**
	 * Shortens the text content of each element in the set of matched elements by truncating it with an ellipsis.
	 * @param {Object} [options] - An object that contains one or more of the following properties:
	 * @param {number} [options.showLines=2] - The number of lines to show.
	 * @param {string} [options.ellipsesText="..."] - The text to display for the ellipsis.
	 * @param {string} [options.moreText="more"] - The text for the "more" link.
	 * @param {string} [options.lessText="less"] - The text for the "less" link.
	 */
	$.fn.TI_shorten = function (settings) {
		var config = {
			showLines: 2,
			ellipsesText: "...",
			moreText: "more",
			lessText: "less"
		};

		if (settings) {
			$.extend(config, settings);
		}

		return this.each(function () {
			var $this = $(this);
			if ($this.hasClass("shortened")) return;

			$this.addClass("shortened").css({
				'-webkit-line-clamp': config.showLines.toString(),
				'display': '-webkit-box',
				'overflow': 'hidden',
				'-webkit-box-orient': 'vertical'
			});

			if ($this.get(0).scrollHeight > $this.get(0).clientHeight) {
				let btn = $('<a href="#" style="text-decoration: none; display: block" class="morelink">' + config.moreText + '</a>');

				$this.after(btn);
				btn.on('click', function (event) {
					event.preventDefault();

					if (btn.html() == config.moreText) {
						$this.css({
							'-webkit-line-clamp': "unset",
							'overflow': 'visible'
						});

						btn.html(config.lessText);
					} else {
						$this.css({
							'-webkit-line-clamp': config.showLines.toString(),
							'overflow': 'hidden'
						});

						btn.html(config.moreText);
					}

					return false;
				});
			}
		});
	};

	/**
	 * Formats the text of each element in the set of matched elements.
	 *
	 * @param {string} svg_good - The SVG code for a good rating.
	 * @param {string} svg_bad - The SVG code for a bad rating.
	 * @returns {jQuery} The jQuery object.
	 */
	$.fn.TI_format = function () {
		let svg_good = '<span class="ti-prokontra-good"><svg viewBox="0 0 128 128"><path d="M64 8a56 56 0 1 0 56 56A56 56 0 0 0 64 8zm0 104a48 48 0 1 1 48-48 48 48 0 0 1-48 48zM44 64a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm48-8a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm-4.8 21.6a4 4 0 0 1 .6 3.6A24.3 24.3 0 0 1 64 97c-9.7 0-15.7-4.2-19-7.8a22.7 22.7 0 0 1-4.8-8A4 4 0 0 1 44 76h40a4 4 0 0 1 3.2 1.6z"></path></svg></span>';
		let svg_bad = '<span class="ti-prokontra-bad"><svg viewBox="0 0 128 128"><path d="M64 8a56 56 0 1 0 56 56A56 56 0 0 0 64 8zm0 104a48 48 0 1 1 48-48 48 48 0 0 1-48 48zM44 64a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm48-8a8 8 0 1 1-8-8 8 8 0 0 1 8 8zm-5.2 30.2a4 4 0 1 1-5.6 5.6c-10.5-10.4-24-10.4-34.4 0a4 4 0 0 1-5.6-5.6c13.6-13.7 32-13.7 45.6 0z"></path></svg></span>';

		return this.each(function () {
			let el = $(this);
			let html = el.html();

			//Booking PRO-KONTRA
			html = html.replace(/^☺/m, svg_good).replace(/^☹/m, svg_bad);

			//nl2br
			html = html.trim().replace(/\n/g, "<br />");

			el.html(html);
		});
	};

	/**
	 * Initializes an image uploader on the selected jQuery element(s).
	 *
	 * This function allows users to upload images by either clicking a button to open the file dialog,
	 * or by dragging and dropping images onto the element. It supports multiple image uploads, displays
	 * thumbnails of the uploaded images, and allows setting a limit on the number of images that can be uploaded.
	 *
	 * @param {number} limit - The maximum number of images that can be uploaded.
	 */
	$.fn.imageUploader = function(limit) {
		$(this).each(function() {
			let uploader = $(this);
			let button = uploader.find('.btn-image-upload');

			// create background file input
			let input = $('<input type="file" multiple="true" accept=".jpg, .png, .bmp">');

			// display image
			let add = function(src) {
				// check limit
				if (uploader.find('.item').length >= limit) {
					showError('limit');

					return false;
				}

				let el = $('<div class="item"><span class="remove"><i aria-hidden="true" class="fa fa-trash"></i></span><div class="image"><img /></div><textarea placeholder="'+ uploader.data('caption-placeholder') +'" rows="2"></textarea></div>');
				el.find('img').attr('src', src);

				// append to dom
				uploader.find('content').append(el);
			};

			// show error function
			let errorTimeout = null;
			let showError = function(type) {
				if (errorTimeout) {
					clearTimeout(errorTimeout);
				}

				let box = uploader.find('.error-text.type-' + type);
				if (box.length) {
					box.show();

					errorTimeout = setTimeout(function() {
						box.fadeOut();
					}, 4000);
				}
			};

			// handle function
			let handleFiles = function(files) {
				if (files.length) {
					let finished = 0;

					// show processing notification
					uploader.find('.processing').show();

					// iterate through files
					Array.from(files).forEach(function(f) {
						// check if we got an image
						if (f.type.split('/')[0] !== 'image') {
							return;
						}

						// load image with 3rd party lib
						loadImage.parseMetaData(f, function(data) {
							// options to resize & return canvas
							let options = {
								maxWidth: 2000,
								maxHeight: 2000,
								canvas: true,
								meta: true,
								parseMetaData: true // for exif
							};

							// image created on a telephone and maybe needed a rotation
							if (data.exif !== undefined && data.exif.get('Orientation') !== undefined) {
								options.orientation = data.exif.get('Orientation');
							}

							// load
							loadImage(f, function(canvas) {
								finished++;

								// display
								add(canvas.toDataURL('image/jpeg', 0.95));

								// hide processing notification
								if (finished >= files.length) {
									uploader.find('.processing').hide();
								}
							}, options);
						});
					});
				}
			};

			// button click, trigger input file click
			button.on('click', function() {
				input.click();
				return false;
			});

			// input changed, handle files
			input.change(function() {
				handleFiles(input.get(0).files);
				input.val('');
			});

			// drag events
			['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function(type) {
				uploader.get(0).addEventListener(type, function(event) {
					event.preventDefault();
					event.stopPropagation();

					// add-remove classes
					if (type === 'dragenter' || type === 'dragover') {
						uploader.addClass('on-drag');
					}
					else if (type === 'dragleave' || type === 'drop') {
						uploader.removeClass('on-drag');
					}

					// handle files
					if (type === 'drop') {
						handleFiles(event.dataTransfer.files);
					}
				}, false);
			});
		});
	};
}
